import React from 'react'

export interface SocialMediaCardProps {
  texts: string[]
  images: {
    src: string
    alt: string
    link?: string
  }[]
  widthContainer?: number | string
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse'
  alignItems?: string
  backgroundColor?: string
  justifyContent?: string
  imgWidth?: number | string
}

const SocialMediaCard: React.FC<SocialMediaCardProps> = ({
  images,
  texts,
  flexDirection,
  alignItems,
  backgroundColor,
  widthContainer,
  justifyContent,
  imgWidth,
}) => {
  const styleContainer = {
    display: 'flex',
    width: widthContainer ?? undefined,
    alignItems: alignItems ?? 'center',
    flexDirection: flexDirection ?? 'column',
    backgroundColor: backgroundColor ?? '#F4F4F4',
  }

  const styledLogo = {
    display: 'flex',
    justifyContent: justifyContent ?? 'space-between',
    width: imgWidth ?? undefined,
  }

  return (
    <div className="container-social-media" style={styleContainer}>
      <div className="container-text">
        {texts.map((text) => (
          <p key={text}>{text}</p>
        ))}
      </div>

      <div className="container-images" style={styledLogo}>
        {images
          .filter((image) => !!image.link)
          .map((image) => (
            <a
              href={image.link}
              target="_blank"
              key={image.link}
              rel="noreferrer"
            >
              <img src={image.src} alt={image.alt} />
            </a>
          ))}
      </div>
    </div>
  )
}

export default SocialMediaCard
